// Module
var code = "<div> <div class=\"name\">Application Stage</div> <template v-if=\"editing == true\"> <dropdown-field label=\"Application Stage\" :validation=\"validation.stage\" :value.sync=\"filter.stage\" :options=\"stages\"></dropdown-field> </template> <template v-if=\"editing == false\"> {{ selectedStage }} </template> </div> ";
// Exports
export default code;